// extracted by css-extract-rspack-plugin
export default {"Octicon_0":"FilterRevert-module__Octicon_0__MTK3_93","Link_0":"FilterRevert-module__Link_0__AbBHON2"};